import { useNavigate } from 'react-router-dom'
import { motion } from 'framer-motion'
import {
  Box,
  Typography,
  Button,
} from '@mui/material'
import Carousel from 'react-material-ui-carousel'

const carouselItems = [
  {
    image: '/images/hotel-front.jpeg',
    title: 'Welcome to Bisworupa Inn',
    description: 'Experience luxury and comfort in the heart of Puri'
  },
  {
    image: '/images/rooms/family-suite/room-1.jpeg',
    title: 'Family Suite',
    description: 'Spacious accommodation perfect for family getaways'
  },
  {
    image: '/images/rooms/super-deluxe/room-1.jpeg',
    title: 'Super Deluxe Room',
    description: 'Experience luxury and comfort at its finest'
  },
  {
    image: '/images/rooms/deluxe-ac/room-1.jpeg',
    title: 'Deluxe AC Room',
    description: 'Modern comfort with elegant design'
  }
]

const HeroSection = () => {
  const navigate = useNavigate()

  return (
    <Box sx={{ 
      position: 'relative',
      height: '100vh',
      width: '100%',
      overflow: 'hidden'
    }}>
      <Carousel
        animation="slide"
        duration={800}
        interval={6000}
        indicators={true}
        navButtonsAlwaysVisible={false}
        navButtonsAlwaysInvisible={true}
        sx={{
          height: '100%',
        }}
        indicatorContainerProps={{
          style: {
            position: 'absolute',
            bottom: '40px',
            zIndex: 2,
          }
        }}
        indicatorIconButtonProps={{
          style: {
            color: 'rgba(255, 255, 255, 0.4)',
            margin: '0 8px',
          }
        }}
        activeIndicatorIconButtonProps={{
          style: {
            color: '#1976d2', // primary.main
          }
        }}
      >
        {carouselItems.map((item, index) => (
          <Box
            key={index}
            sx={{
              height: '100vh',
              position: 'relative',
              '&::after': {
                content: '""',
                position: 'absolute',
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                backgroundColor: 'rgba(0, 0, 0, 0.5)',
                zIndex: 1,
              },
              '&::before': {
                content: '""',
                position: 'absolute',
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                background: 'linear-gradient(to bottom, transparent 0%, rgba(0, 0, 0, 0.7) 100%)',
                zIndex: 2,
              }
            }}
          >
            <Box
              component="img"
              src={item.image}
              alt={item.title}
              sx={{
                width: '100%',
                height: '100%',
                objectFit: 'cover',
              }}
            />
            <Box
              sx={{
                position: 'absolute',
                top: '50%',
                left: '50%',
                transform: 'translate(-50%, -50%)',
                textAlign: 'center',
                zIndex: 3,
                width: '100%',
                px: 4,
              }}
            >
              <motion.div
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.8 }}
              >
                <Typography
                  variant="h1"
                  sx={{
                    color: 'white',
                    fontFamily: '"Playfair Display", serif',
                    fontSize: { xs: '2.5rem', md: '4rem' },
                    mb: 2,
                    textShadow: '2px 2px 4px rgba(0,0,0,0.3)',
                  }}
                >
                  {item.title}
                </Typography>
                <Typography
                  variant="h5"
                  sx={{
                    color: 'white',
                    mb: 4,
                    textShadow: '1px 1px 2px rgba(0,0,0,0.3)',
                    fontWeight: 300,
                  }}
                >
                  {item.description}
                </Typography>
                { (
                  <Button
                    variant="contained"
                    size="large"
                    onClick={() => navigate('/rooms')}
                    sx={{
                      backgroundColor: 'primary.main',
                      color: 'white',
                      px: 4,
                      py: 1.5,
                      fontSize: '1.1rem',
                      '&:hover': {
                        backgroundColor: 'primary.dark',
                      },
                    }}
                  >
                    Book Now
                  </Button>
                )}
              </motion.div>
            </Box>
          </Box>
        ))}
      </Carousel>
    </Box>
  )
}

export default HeroSection 